import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { SettingsDepositModel } from "../models/settings-deposit.model";

import "rxjs/add/operator/toPromise";
import { BaseService } from "./api-base.service";
import { ReconApiService } from "./recon-api.service";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class DepositSettingsService {
  private currentSettings: SettingsDepositModel = null;
  constructor(
    private apiBase: BaseService,
    private http: HttpClient,
    private reconApiService: ReconApiService
  ) {}

  public get currentDepositSettings(): SettingsDepositModel {
    return this.currentSettings;
  }

  public async getDepositSettings(
    clientId: string
  ): Promise<SettingsDepositModel> {
    let uri = `${environment.reconApiRoot.url}/client/${clientId}/ClientSettings/DepositSettings/`;
    let response = await this.http
      .get<SettingsDepositModel>(uri, { headers: this.apiBase.getHeaders() })
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        return null;
      });
    this.currentSettings = response;
    return response;
  }

  public async saveDepositSettings(
    clientId: string,
    request: SettingsDepositModel
  ): Promise<boolean> {
    const url = `${environment.reconApiRoot.url}/client/${clientId}/ClientSettings/DepositSettings/`;
    const response = await this.http
      .put(
        url,
        request,
        { headers: this.apiBase.getHeaders() }
      )
      .toPromise()
      .catch((error) => {
        console.log(
          `Error occurred at ${new Date()} status: ${error.status.toString()}`
        );
        this.reconApiService.logToElasticSearchFromUI(
          error,
          url
        );
        return false;
      });
    this.showSaveSuccess("Deposit Settings");
    this.currentSettings = request;
    return true;
  }

  private showSaveSuccess(source: string) {
    toastr.success(`${source} updated successfully!`);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/depositSettings-api.service.ts